/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsClockAdd: {
  name: 'clock-add';
  data: string;
} = {
  name: 'clock-add',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1.5A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 1 1 0A7.5 7.5 0 1 1 8 .5a.5.5 0 0 1 0 1Zm5.5-.5a.5.5 0 0 0-1 0v1.5H11a.5.5 0 0 0 0 1h1.5V5a.5.5 0 0 0 1 0V3.5H15a.5.5 0 0 0 0-1h-1.5V1Zm-5 4a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1H8.5V5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
